import { render, staticRenderFns } from "./HomeVision.vue?vue&type=template&id=0aa49bef&scoped=true&"
import script from "./HomeVision.vue?vue&type=script&lang=js&"
export * from "./HomeVision.vue?vue&type=script&lang=js&"
import style0 from "./HomeVision.vue?vue&type=style&index=0&id=0aa49bef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa49bef",
  null
  
)

export default component.exports